import Container from 'components/ui/Container';
import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useRoutineWiseSessionFeedbackCountQuery } from 'redux/reducers/Feedback/sessionAndModuleFeedback';
interface IFeedbackResult {
  status: boolean;
}
interface CustomizedState {
  topic: string;
}
const QuestionsAndAnswers: FC<IFeedbackResult> = ({ status }) => {
  const { routineId, sessionId } = useParams<{ routineId: string; sessionId: string }>();
  let location = useLocation();
  const state = location.state as CustomizedState; // Type Casting, then you can get the params passed via router
  const { topic } = state;
  const { data: feedbackData } = useRoutineWiseSessionFeedbackCountQuery({ routineId, sessionId });
  const shortAnswerQuestion = feedbackData?.data?.filter((data: any, index: number) => {
    return data.question_type === 's';
  });
  console.log('feedbackData', feedbackData);

  return (
    <>
      <Container title="">
        <h4>{shortAnswerQuestion?.length ? null : 'No record'} </h4>
        {shortAnswerQuestion?.map((data: any) => {
          return (
            <>
              <p>
                <strong>{data?.question}</strong>
              </p>

              {data?.feedback_answer_data?.map((answer: any) => {
                return (
                  <>
                    <p>- {answer?.feedback_answer}</p>
                  </>
                );
              })}
            </>
          );
        })}
      </Container>
    </>
  );
};

export default QuestionsAndAnswers;
